import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./lib/ThemeContext";
import "./App.css";

import { Layout } from "./components/Layout";
import { SiteBanner } from "./components/SiteBanner";
import Home from "./pages/Home";
import About from "./pages/About";
import Visit from "./pages/Visit";
import Responsible from "./pages/Responsible";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Accessibility from "./pages/Accessibility";
import Spirits from "./pages/Spirits";
import SpiritDetail from "./pages/SpiritDetail";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Recipes from "./pages/Recipes";
import RecipeDetail from "./pages/RecipeDetail";
import Local from "./pages/Local";
import AttractionDetail from "./pages/AttractionDetail";
import LandingPage from "./pages/LandingPage";
import Reviews from "./pages/Reviews";
import Contact from "./pages/Contact";
import FAQ from "./pages/FAQ";
import NotFound from "./pages/NotFound";
import LegacyRedirect from "./components/LegacyRedirect";
import AdminApp from "./admin/AdminApp";

const PublicSite = () => (
    <>
        <SiteBanner />
        <Layout>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/visit" element={<Visit />} />
                <Route path="/spirits" element={<Spirits />} />
                <Route path="/spirits/category/:category" element={<Spirits />} />
                <Route path="/spirits/:slug" element={<SpiritDetail />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/category/:category" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/recipes" element={<Recipes />} />
                <Route path="/recipes/:slug" element={<RecipeDetail />} />
                <Route path="/local/clinton-mo" element={<Local />} />
                <Route path="/local/:slug" element={<AttractionDetail />} />
                <Route path="/locations/:slug" element={<LandingPage />} />
                <Route path="/categories/:slug" element={<LandingPage />} />
                <Route path="/guides/:slug" element={<LandingPage />} />
                <Route path="/gift-cards" element={<LandingPage />} />
                <Route path="/curbside-pickup" element={<LandingPage />} />
                <Route path="/events-and-weddings" element={<LandingPage />} />
                <Route path="/business-accounts" element={<LandingPage />} />
                <Route path="/local/truman-lake-marina-guide" element={<LandingPage />} />
                <Route path="/reviews" element={<Reviews />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/responsible-drinking" element={<Responsible />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/accessibility" element={<Accessibility />} />
                <Route path="*" element={<LegacyRedirect fallback={<NotFound />} />} />
            </Routes>
        </Layout>
    </>
);

function App() {
    return (
        <HelmetProvider>
            <ThemeProvider>
                <div className="App">
                    <BrowserRouter>
                        <Routes>
                            <Route path="/admin/*" element={<AdminApp />} />
                            <Route path="/*" element={<PublicSite />} />
                        </Routes>
                    </BrowserRouter>
                </div>
            </ThemeProvider>
        </HelmetProvider>
    );
}

export default App;
